import { Wei } from '../../utils/types'
import { fromWei } from '../../utils/static-web3'
import currencyLogo from '../../components/CurrencyLogo'

const PRECISION = 7

/**
 * Used to display a quantity of token with a precision of 7
 * TODO:rename so that we know the input type
 * @param n
 */
export function precise(n: number): string {
  return n ? n.toPrecision(PRECISION) : ''
}

/**
 * precise() with a lower precision
 * @param n
 */
export function precise3(n: number): string {
  return n ? n.toPrecision(3) : ''
}

/**
 * Used to display a price with a variable precision, to avoid too much 0 and exponential display
 * @param num
 */
export function priceFormatter(num: number, finalPrecision = 6) {
  if (num === 0 || isNaN(num) || num == undefined) {
    return '0'
  }
  const price = num.toPrecision(18)

  // case of very small number
  if (num < 0.00001) {
    return '< 0.00001'
  }
  if (num < 0.001) {
    // we display up to 6 numbers
    return `${price.slice(0, finalPrecision + 3)}`
  }
  if (num < 1) {
    return `${price.slice(0, finalPrecision + 2)}`
  }
  const [integer, float] = price.split('.')
  let keepFloatLength = finalPrecision - integer.length
  if (keepFloatLength < 0) {
    keepFloatLength = 0
  }

  let letters = numberWithCommas(integer)
  const result =
    keepFloatLength > 0
      ? `${letters}.${float.slice(0, keepFloatLength)}`
      : letters
  return precision(result, finalPrecision)
}

function precision(valueWithComma: string, precision = 6) {
  let result = ''
  let count = 0
  for (let i = 0; i < valueWithComma.length; i++) {
    let n = valueWithComma[i]
    if (n >= '0' && n <= '9') {
      if (count < precision) {
        result += n
        count++
      } else {
        result += '0'
      }
    } else {
      // ',' or '.'
      result += n
    }
  }
  return result
}

function numberWithCommas(x: number | string) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
